<template>
  <div class="toolbar" :style="toolbarCss">
    <img
      :src="toolbar_item_1"
      @click="profile"
      class="toolbar_item_1"
      :style="getStyle1()"
    />
    <img
      :src="toolbar_item_2"
      @click="cars"
      class="toolbar_item_2"
      :style="getStyle2()"
    />
    <img
      :src="toolbar_item_3"
      @click="home"
      class="toolbar_item_3"
      :style="getStyle3()"
    />
    <img
      :src="toolbar_item_4"
      @click="marketing"
      class="toolbar_item_4"
      :style="getStyle4()"
    />
    <img
      :src="toolbar_item_5"
      @click="payments"
      class="toolbar_item_5"
      :style="getStyle5()"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      toolbarCss: { "margin-top": window.innerHeight * 0.95 + "px" },
      toolbar_item_1: require("@/assets/new_design/vector_1.png"),
      toolbar_item_2: require("@/assets/new_design/vector_2.png"),
      toolbar_item_3: require("@/assets/new_design/vector_3.png"),
      toolbar_item_4: require("@/assets/new_design/vector_4.png"),
      toolbar_item_5: require("@/assets/new_design/vector_5.png"),
      getStyle1: () => {
        return this.$store.getters.SELECTED_TOOLBAR_ITEM === 1
          ? { border: "2px solid rgba(114, 174, 255, 1)" }
          : {};
      },
      getStyle2: () => {
        return this.$store.getters.SELECTED_TOOLBAR_ITEM === 2
          ? { border: "2px solid rgba(114, 174, 255, 1)" }
          : {};
      },
      getStyle3: () => {
        return this.$store.getters.SELECTED_TOOLBAR_ITEM === 3
          ? { border: "2px solid rgba(114, 174, 255, 1)" }
          : {};
      },
      getStyle4: () => {
        return this.$store.getters.SELECTED_TOOLBAR_ITEM === 4
          ? { border: "2px solid rgba(114, 174, 255, 1)" }
          : {};
      },
      getStyle5: () => {
        return this.$store.getters.SELECTED_TOOLBAR_ITEM === 5
          ? { border: "2px solid rgba(114, 174, 255, 1)" }
          : {};
      },
      profile: () => {
        if (this.$route.name !== "Profile") {
          this.$router.push("/profile");
        }
        this.$store.dispatch("TOOLBAR_CLICK_ACTION", 1);
      },
      payments: () => {
        if (this.$route.name !== "CardsList") {
          this.$router.push("/cardsListSquare");
        }
        this.$store.dispatch("TOOLBAR_CLICK_ACTION", 5);
      },
      // loyalty: () => {
      //   if (this.$route.name !== "LoyaltyList") {
      //     this.$router.push("/loyaltyList");
      //   }
      // },
      marketing: () => {
        if (this.$route.name !== "MarketCampagnsList") {
          this.$router.push("/marketCampagnsList");
        }
        this.$store.dispatch("TOOLBAR_CLICK_ACTION", 4);
      },
      cars: () => {
        if (this.$route.name !== "CarsList") {
          this.$router.push("/carsList");
        }
        this.$store.dispatch("TOOLBAR_CLICK_ACTION", 2);
      },
      home: () => {
        if (this.$store.getters.USER_HAVE_ACTIVE_PARKING) {
          if (this.$route.name !== "CurrentParking") {
            this.$router.push("/currentParking");
          }
        } else {
          if (this.$route.name !== "ParkendaValet") {
            this.$router.push("/parkendaValet");
          }
        }
        this.$store.dispatch("TOOLBAR_CLICK_ACTION", 3);
      }
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.toolbar {
  background-color: #dedede;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  position: absolute;
  height: 5vh;
}
.toolbar img {
  height: 23px;
  width: 23px;
  border: 1px solid white;
  padding: 3px;
  border-radius: 30px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ParkendaToolbar.vue